var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"router-tabs",attrs:{"role":"navigation"}},[_c('ul',{staticClass:"nav nav-tabs"},_vm._l((_vm.shownRoutes),function(r){return _c('router-tab',{key:r.name,attrs:{"route":r}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }